import { all, spawn } from 'redux-saga/effects';
import authSagas from '@iso/redux/auth/saga';
import usersSagas from '@iso/redux/users/saga';
import invoicesSagas from '@iso/redux/invoice/saga';
import mailSagas from '@iso/redux/mail/saga';
import denunciasSagas from '@iso/redux/denuncias/sagas';
import profileSaga from '@iso/redux/profile/saga';
import empresasSagas from '@iso/redux/empresas/saga';
import appSagas from '@iso/redux/app/saga';
import productoSagas from '@iso/redux/productos/saga';
import ventasSagas from '@iso/redux/ventas/saga';
import inventarioSagas from '@iso/redux/inventario/saga';
import opsSagas from '@iso/redux/ops/saga';
import usersRRHHSagas from '@iso/redux/RRHH/saga';
import cajaSagas from '@iso/redux/caja/saga';
import proveedorSagas from '@iso/redux/proveedores/saga';
import cotizacionesSagas from '@iso/redux/cotizaciones/saga';
import comprasSagas from '@iso/redux/compras/saga';
import notasCierreSagas from '@iso/redux/notasCierre/saga';
import downloadsSagas from '@iso/redux/downloads/saga';
import pedidosOnline from '@iso/redux/pedidosOnline/saga';
import Siigo from '@iso/redux/Siigo/saga';
import Contabilidad from '@iso/redux/contabilidad/saga';
import ConciliacionBancariaSagas from '@iso/redux/conciliacionBancaria/saga';
import estadisticasSagas from '@iso/redux/estadisticas/saga';
import MovCajaAuxSagas from '@iso/redux/movCajaAux/saga';
import BitacorasSagas from '@iso/redux/bitacoras/saga';
import socketSaga from '@iso/redux/socket/saga';
import montajesSagas from '@iso/redux/montajes/saga';
import valesConsumoSagas from '@iso/redux/valesConsumo/saga';
import bonificacionesSagas from '@iso/redux/bonificaciones/saga';
import soporteSagas from '@iso/redux/soporte/saga';

export default function* rootSaga(getState) {
  yield all([
    spawn(authSagas),
    spawn(usersSagas),
    spawn(mailSagas),
    spawn(invoicesSagas),
    spawn(denunciasSagas),
    spawn(profileSaga),
    spawn(empresasSagas),
    spawn(appSagas),
    spawn(productoSagas),
    spawn(ventasSagas),
    spawn(inventarioSagas),
    spawn(opsSagas),
    spawn(usersRRHHSagas),
    spawn(cajaSagas),
    spawn(proveedorSagas),
    spawn(cotizacionesSagas),
    spawn(comprasSagas),
    spawn(notasCierreSagas),
    spawn(downloadsSagas),
    spawn(pedidosOnline),
    spawn(Siigo),
    spawn(Contabilidad),
    spawn(ConciliacionBancariaSagas),
    spawn(estadisticasSagas),
    spawn(MovCajaAuxSagas),
    spawn(BitacorasSagas),
    spawn(socketSaga),
    spawn(montajesSagas),
    spawn(valesConsumoSagas),
    spawn(bonificacionesSagas),
    spawn(soporteSagas),
  ]);
}
